import { memo } from 'react';
import { DialogActions, DialogButton } from '~/components/ui/Dialog';

interface DnsIssuesSectionProps {
  checkingDns: boolean;
  onCheckDnsStatus: () => void;
}

export const DnsIssuesSection = memo(({ checkingDns, onCheckDnsStatus }: DnsIssuesSectionProps) => {
  return (
    <section className="flex gap-2 text-sm justify-between">
      <div className="flex flex-col gap-2">
        <h3 className="font-semibold text-bolt-ds-textPrimary">You have some pending DNS issues.</h3>

        <p className="text-bolt-ds-textSecondary w-5/6">
          Once you've followed the instructions, click the button below to check the current status of your DNS.
        </p>
      </div>

      <DialogActions className="p-0 self-start justify-center shrink-0">
        <DialogButton
          size="md"
          variant="secondary"
          disabled={checkingDns}
          onClick={onCheckDnsStatus}
          truncate={false}
          className="flex items-center gap-2"
        >
          {checkingDns ? (
            <>
              <span className="i-svg-spinners:90-ring-with-bg size-4 inline-block" />
              Checking...
            </>
          ) : (
            <>Check DNS status</>
          )}
        </DialogButton>
      </DialogActions>
    </section>
  );
});
